import { createElement, Component } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Device = /** @class */ (function (_super) {
    __extends(Device, _super);
    function Device() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Device.prototype.render = function () {
        var _a = this.props, device = _a.device, orientation = _a.orientation, color = _a.color, width = _a.width, wrapperProps = _a.wrapperProps, buttonProps = _a.buttonProps, screenProps = _a.screenProps, children = _a.children;
        return (createElement("div", __assign({}, wrapperProps, { className: 'device-wrapper', style: __assign({ maxWidth: width, width: width }, (wrapperProps && wrapperProps.style ? wrapperProps.style : {})) }),
            createElement("div", { className: 'device', "data-device": device, "data-orientation": orientation, "data-color": color },
                createElement("div", __assign({ className: 'screen' }, screenProps), children),
                createElement("div", __assign({ className: 'button' }, buttonProps)))));
    };
    return Device;
}(Component));

var Chromebook = /** @class */ (function (_super) {
    __extends(Chromebook, _super);
    function Chromebook() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Chromebook.prototype.render = function () {
        return (createElement(Device, __assign({}, this.props, { device: 'Chromebook', orientation: 'portrait', color: 'black' })));
    };
    return Chromebook;
}(Component));

var GalaxyS3 = /** @class */ (function (_super) {
    __extends(GalaxyS3, _super);
    function GalaxyS3() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GalaxyS3.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'galaxyS3' })));
    };
    return GalaxyS3;
}(Component));

var GalaxyS5 = /** @class */ (function (_super) {
    __extends(GalaxyS5, _super);
    function GalaxyS5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GalaxyS5.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'galaxyS5' })));
    };
    return GalaxyS5;
}(Component));

var GalaxyTab4 = /** @class */ (function (_super) {
    __extends(GalaxyTab4, _super);
    function GalaxyTab4() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GalaxyTab4.prototype.render = function () {
        return (createElement(Device, __assign({ color: 'black' }, this.props, { device: 'galaxyTab4', orientation: 'portrait' })));
    };
    return GalaxyTab4;
}(Component));

var HTCOneM8 = /** @class */ (function (_super) {
    __extends(HTCOneM8, _super);
    function HTCOneM8() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HTCOneM8.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait' }, this.props, { device: 'HtcOneM8', color: 'black' })));
    };
    return HTCOneM8;
}(Component));

var HuaweiP8 = /** @class */ (function (_super) {
    __extends(HuaweiP8, _super);
    function HuaweiP8() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HuaweiP8.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait' }, this.props, { device: 'HuaweiP8', color: 'gold' })));
    };
    return HuaweiP8;
}(Component));

var IMac = /** @class */ (function (_super) {
    __extends(IMac, _super);
    function IMac() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IMac.prototype.render = function () {
        return (createElement(Device, __assign({}, this.props, { device: 'iMac', orientation: 'portrait', color: 'black' })));
    };
    return IMac;
}(Component));

var IPad = /** @class */ (function (_super) {
    __extends(IPad, _super);
    function IPad() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPad.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'iPad' })));
    };
    return IPad;
}(Component));

var IPadAir2 = /** @class */ (function (_super) {
    __extends(IPadAir2, _super);
    function IPadAir2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPadAir2.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'iPadAir2' })));
    };
    return IPadAir2;
}(Component));

var IPadPro = /** @class */ (function (_super) {
    __extends(IPadPro, _super);
    function IPadPro() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPadPro.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'iPadPro' })));
    };
    return IPadPro;
}(Component));

var IPhone5 = /** @class */ (function (_super) {
    __extends(IPhone5, _super);
    function IPhone5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhone5.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'iPhone5' })));
    };
    return IPhone5;
}(Component));

var IPhone6 = /** @class */ (function (_super) {
    __extends(IPhone6, _super);
    function IPhone6() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhone6.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'iPhone6' })));
    };
    return IPhone6;
}(Component));

var IPhone6Hand = /** @class */ (function (_super) {
    __extends(IPhone6Hand, _super);
    function IPhone6Hand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhone6Hand.prototype.render = function () {
        return (createElement(Device, __assign({ color: 'black' }, this.props, { device: 'iPhone6Hand', orientation: 'portrait' })));
    };
    return IPhone6Hand;
}(Component));

var IPhone6Plus = /** @class */ (function (_super) {
    __extends(IPhone6Plus, _super);
    function IPhone6Plus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhone6Plus.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'iPhone6Plus' })));
    };
    return IPhone6Plus;
}(Component));

var IPhone7 = /** @class */ (function (_super) {
    __extends(IPhone7, _super);
    function IPhone7() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhone7.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'iPhone7' })));
    };
    return IPhone7;
}(Component));

var IPhone7Hand = /** @class */ (function (_super) {
    __extends(IPhone7Hand, _super);
    function IPhone7Hand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhone7Hand.prototype.render = function () {
        return (createElement(Device, __assign({}, this.props, { device: 'iPhone7Hand', orientation: 'portrait', color: 'black' })));
    };
    return IPhone7Hand;
}(Component));

var IPhone7Hand2 = /** @class */ (function (_super) {
    __extends(IPhone7Hand2, _super);
    function IPhone7Hand2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhone7Hand2.prototype.render = function () {
        return (createElement(Device, __assign({}, this.props, { device: 'iPhone7Hand_2', orientation: 'portrait', color: 'black' })));
    };
    return IPhone7Hand2;
}(Component));

var IPhoneSE = /** @class */ (function (_super) {
    __extends(IPhoneSE, _super);
    function IPhoneSE() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhoneSE.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'iPhoneSE' })));
    };
    return IPhoneSE;
}(Component));

var IPhoneX = /** @class */ (function (_super) {
    __extends(IPhoneX, _super);
    function IPhoneX() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IPhoneX.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait' }, this.props, { device: 'iPhoneX', color: 'black' })));
    };
    return IPhoneX;
}(Component));

var Lumia930 = /** @class */ (function (_super) {
    __extends(Lumia930, _super);
    function Lumia930() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Lumia930.prototype.render = function () {
        return (createElement(Device, __assign({ orientation: 'portrait', color: 'black' }, this.props, { device: 'Lumia930' })));
    };
    return Lumia930;
}(Component));

var Macbook = /** @class */ (function (_super) {
    __extends(Macbook, _super);
    function Macbook() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Macbook.prototype.render = function () {
        return (createElement(Device, __assign({ color: 'black' }, this.props, { device: 'Macbook', orientation: 'portrait' })));
    };
    return Macbook;
}(Component));

var Macbook2015 = /** @class */ (function (_super) {
    __extends(Macbook2015, _super);
    function Macbook2015() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Macbook2015.prototype.render = function () {
        return (createElement(Device, __assign({ color: 'black' }, this.props, { device: 'Macbook2015', orientation: 'portrait' })));
    };
    return Macbook2015;
}(Component));

var MacbookPro = /** @class */ (function (_super) {
    __extends(MacbookPro, _super);
    function MacbookPro() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MacbookPro.prototype.render = function () {
        return (createElement(Device, __assign({}, this.props, { device: 'MacbookPro', orientation: 'portrait', color: 'black' })));
    };
    return MacbookPro;
}(Component));

var Pixel = /** @class */ (function (_super) {
    __extends(Pixel, _super);
    function Pixel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pixel.prototype.render = function () {
        return (createElement(Device, __assign({ color: 'black' }, this.props, { device: 'Pixel', orientation: 'portrait' })));
    };
    return Pixel;
}(Component));

var SamsungTV = /** @class */ (function (_super) {
    __extends(SamsungTV, _super);
    function SamsungTV() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SamsungTV.prototype.render = function () {
        return (createElement(Device, __assign({}, this.props, { device: 'SamsungTV', orientation: 'portrait', color: 'black' })));
    };
    return SamsungTV;
}(Component));

var SurfacePro3 = /** @class */ (function (_super) {
    __extends(SurfacePro3, _super);
    function SurfacePro3() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurfacePro3.prototype.render = function () {
        return (createElement(Device, __assign({}, this.props, { device: 'SurfacePro3', orientation: 'landscape', color: 'black' })));
    };
    return SurfacePro3;
}(Component));

var SurfaceStudio = /** @class */ (function (_super) {
    __extends(SurfaceStudio, _super);
    function SurfaceStudio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurfaceStudio.prototype.render = function () {
        return (createElement(Device, __assign({}, this.props, { device: 'SurfaceStudio', orientation: 'portrait', color: 'black' })));
    };
    return SurfaceStudio;
}(Component));

export default Device;
export { Device, Chromebook, GalaxyS3, GalaxyS5, GalaxyTab4, HTCOneM8, HuaweiP8, IMac, IPad, IPadAir2, IPadPro, IPhone6, IPhone6Plus, IPhoneSE, IPhone5, IPhone6Hand, IPhone7Hand, IPhone7Hand2, IPhone7, IPhoneX, Lumia930, Macbook, Macbook2015, MacbookPro, Pixel, SamsungTV, SurfacePro3, SurfaceStudio };
//# sourceMappingURL=index.es.js.map
